export default class PollVoteBasicModel {
  public id: string = null;
  public pollId: string = null;
  public optionId: string = null;
  public optionIds: string[] = [];
  public userId: string = null;
  public createdAt: string = null;
}
